import { DateConverter } from '@shared/entities/converters/date-converter';
import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('Mission')
export class Mission extends Entity {
  @JsonProperty('period', DateConverter)
  public period?: Date = undefined;
  @JsonProperty('pickingMissions', Number)
  public pickingMissions?: number = undefined;
  @JsonProperty('refillingMissions', Number)
  public refillingMissions?: number = undefined;
  @JsonProperty('pickingMissionsHour', Number)
  public pickingMissionsHour?: number = undefined;
  @JsonProperty('refillingMissionsHour', Number)
  public refillingMissionsHour?: number = undefined;
  @JsonProperty('execTimeInSeconds', Number)
  public execTimeInSeconds?: number = undefined;
  @JsonProperty('execTimeInHours', Number)
  public execTimeInHours?: number = undefined;
  @JsonProperty('totalMissions', Number)
  public totalMissions?: number = undefined;
}
